import { fork } from 'redux-saga/effects';

import { appSaga } from './app/app.saga';
import { notificationSaga } from './notification/notification.saga';
import { sessionSaga } from './session/session.saga';

export function* rootSaga() {
  yield fork(appSaga);
  yield fork(sessionSaga);
  yield fork(notificationSaga);
}
